import React from 'react';
import classNameBind from 'classnames/bind';
import Button from '../../../Button';
import styles from './SortableHeader.module.css';

const bindClasses = classNameBind.bind(styles);

const SortableHeader = ({
  text = '',
  order,
  selected = false,
  disabled = false,
  breakLongContent = false,
  allowMultiline = false,
  onClick,
  iconLeft,
  dataId = 'List.SortableHeader',
}) => (
  <div className={bindClasses('wrapper', { disabled, allowMultiline })}>
    <Button
      text={text}
      disabled={disabled}
      onClick={onClick}
      iconRight={order ? { asc: 'sort-ascending', dsc: 'sort-descending' }[order] : 'sort-2'}
      appearance={selected ? 'simple' : 'subdued'}
      size="small"
      minimalWidth
      dataId={dataId}
      breakLongContent={breakLongContent || allowMultiline}
      icon={iconLeft}
    />
  </div>
);

SortableHeader.displayName = 'List.SortableHeader';

export default SortableHeader;
